import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "title", "description", "titleSectionSize", "titleTag", "items", "footerDescription", "backgroundColor", "className", "layoutType", "autoSwipe"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import debounce from 'lodash.debounce';
import { useEffect, useMemo, useRef, useState } from 'react';
import { extractSupportProps } from '@sbercloud/uikit-product-utils';
import { Carousel } from '@snack-uikit/carousel';
import { Typography } from '@snack-uikit/typography';
import { CardLeading } from '../../helperComponents';
import { SectionBasic } from '../SectionBasic';
import styles from "./styles.module.css";
import { calculateAmountOfItemsPerPage } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MOBILE_LAYOUTS = ['tablet', 'mobile'];
export function SectionLeading(_ref) {
  var id = _ref.id,
    title = _ref.title,
    description = _ref.description,
    _ref$titleSectionSize = _ref.titleSectionSize,
    titleSectionSize = _ref$titleSectionSize === void 0 ? 'm' : _ref$titleSectionSize,
    titleTag = _ref.titleTag,
    items = _ref.items,
    footerDescription = _ref.footerDescription,
    backgroundColor = _ref.backgroundColor,
    className = _ref.className,
    layoutType = _ref.layoutType,
    _ref$autoSwipe = _ref.autoSwipe,
    autoSwipe = _ref$autoSwipe === void 0 ? 9 : _ref$autoSwipe,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentPage = _useState2[0],
    setCurrentPage = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    itemsPerPageAmount = _useState4[0],
    setItemsPerPageAmount = _useState4[1];
  var wrapperRef = useRef(null);
  useEffect(function () {
    var node = wrapperRef.current;
    if (!node) {
      return;
    }
    var calculateAmountOfItems = function calculateAmountOfItems() {
      var wrapperWidth = node.offsetWidth;
      if (!wrapperWidth) {
        return;
      }
      setItemsPerPageAmount(calculateAmountOfItemsPerPage(wrapperWidth));
    };
    var observer = new ResizeObserver(debounce(calculateAmountOfItems, 100));
    observer.observe(node);
    return function () {
      return observer.disconnect();
    };
  }, []);
  var showArrows = useMemo(function () {
    if (MOBILE_LAYOUTS.includes(layoutType)) {
      return false;
    }
    return items.length > itemsPerPageAmount;
  }, [items.length, itemsPerPageAmount, layoutType]);
  return /*#__PURE__*/_jsx(SectionBasic, _objectSpread(_objectSpread({
    id: id,
    layoutType: layoutType,
    className: className,
    backgroundColor: backgroundColor,
    title: title,
    description: description,
    titleSectionSize: titleSectionSize,
    titleTag: titleTag
  }, extractSupportProps(rest)), {}, {
    children: /*#__PURE__*/_jsxs("div", {
      ref: wrapperRef,
      className: styles.leadingSection,
      "data-layout-type": layoutType,
      children: [itemsPerPageAmount > 0 && /*#__PURE__*/_jsx(Carousel, {
        state: {
          page: currentPage,
          onChange: setCurrentPage
        },
        arrows: showArrows,
        showItems: itemsPerPageAmount,
        pagination: items.length > itemsPerPageAmount,
        swipe: items.length > itemsPerPageAmount,
        autoSwipe: autoSwipe,
        infiniteScroll: true,
        children: items.map(function (item) {
          return /*#__PURE__*/_jsx(CardLeading, _objectSpread(_objectSpread({}, item), {}, {
            layoutType: layoutType,
            "data-test-id": item['data-test-id']
          }), item.label);
        })
      }), footerDescription && /*#__PURE__*/_jsx("div", {
        className: styles.footerDescription,
        "data-layout-type": layoutType,
        children: /*#__PURE__*/_jsx(Typography.SansBodyL, {
          className: styles.footerDescriptionText,
          children: footerDescription
        })
      })]
    })
  }));
}